/**
 * Created by Jerker Nord on 2020-06-05.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MonkeysGoldGameConfig} from "../../MonkeysGoldGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";
import {MonkeysGoldMultiplierBitmapText} from "./MonkeysGoldMultiplierBitmapText";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export class MonkeysGoldBonusGameMultiplierView extends BaseView {

    //private _multiplier:PIXI.spine.Spine;
    private _multiplierValue:number = 0;
    private _multiplierValueIncrease:number = 0;
    private _multiplierContainer:PIXI.Container;
    private _multiplierNumbersContainer:PIXI.Container;
    private static LANDSCAPE_POSITION:PIXI.Point = new PIXI.Point(702, 90);
    private static LANDSCAPE_SCALE:PIXI.Point = new PIXI.Point(0.55, 0.55);
    private static PORTRAIT_POSITION:PIXI.Point = new PIXI.Point(510, -54);
    private static PORTRAIT_SCALE:PIXI.Point = new PIXI.Point(0.85, 0.85);
    private _multiplierActiveText:MonkeysGoldMultiplierBitmapText;
    private _multiplierNextText:MonkeysGoldMultiplierBitmapText;
    private _multiplierUpcomingText:MonkeysGoldMultiplierBitmapText;
    private _isRestore:boolean = false;
    private _multiplierBox:PIXI.Sprite;
    private _multiplierUpdateFrameAnimation:TimelineSprite;
    private _multiplierUpdateExplosionAnimation:TimelineSprite;

    constructor() {
        super();
        StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.BIG_WIN.name).addChild(this);
        this._multiplierContainer = new PIXI.Container();
        this._multiplierContainer.visible = false;
        this.addChild(this._multiplierContainer);
    }

    protected initAnimations():void {

        this._multiplierBox = new PIXI.Sprite(GameResources.getTextures("multiplier")[0]);
        this._multiplierContainer.addChild(this._multiplierBox);

        this._multiplierUpdateFrameAnimation = new TimelineSprite(GameResources.getTextures("fortune_wheel/dice_win_move/multiplier_highlight_"));
        this._multiplierUpdateFrameAnimation.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._multiplierUpdateFrameAnimation.scale.set(1.8, 1.7);
        this._multiplierUpdateFrameAnimation.position.set(-52, 49);
        this._multiplierContainer.addChild(this._multiplierUpdateFrameAnimation);
        this._multiplierUpdateFrameAnimation.visible = false;
        this._multiplierUpdateFrameAnimation.playLoop();

        this._multiplierNumbersContainer = new PIXI.Container();
        this._multiplierContainer.addChild(this._multiplierNumbersContainer);
        this._multiplierNumbersContainer.position.y = 124;

        this._multiplierActiveText = new MonkeysGoldMultiplierBitmapText();
        this._multiplierActiveText.initText();
        this._multiplierActiveText.position.set(68, 0);
        this._multiplierActiveText.enableGoldText();
        this._multiplierNumbersContainer.addChild(this._multiplierActiveText);

        this._multiplierNextText = new MonkeysGoldMultiplierBitmapText();
        this._multiplierNextText.initText();
        this._multiplierNextText.position.set(181, 0);
        this._multiplierNumbersContainer.addChild(this._multiplierNextText);

        this._multiplierUpcomingText = new MonkeysGoldMultiplierBitmapText();
        this._multiplierUpcomingText.initText();
        this._multiplierUpcomingText.position.set(294, 0);
        this._multiplierNumbersContainer.addChild(this._multiplierUpcomingText);

        const maskShape = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(15, -20, 224, 50);
        maskShape.endFill();
        this._multiplierNumbersContainer.addChild(maskShape);
        this._multiplierNumbersContainer.mask = maskShape;

        this._multiplierUpdateExplosionAnimation = new TimelineSprite(GameResources.getTextures("fortune_wheel/dice_win_move/blue blast_"));
        this._multiplierUpdateExplosionAnimation.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._multiplierUpdateExplosionAnimation.scale.set(1.8, 1.7);
        this._multiplierUpdateExplosionAnimation.position.set(106, 44);
        this._multiplierContainer.addChild(this._multiplierUpdateExplosionAnimation);
        this._multiplierUpdateExplosionAnimation.hide();

        if(this._isRestore == true) {
            this.setMultiplierValue(this._multiplierValue, this._multiplierValueIncrease, false, false);
        }
    }

    protected onResize(resizeData:IResizeData):void {
        this._resizeData = resizeData;
        if(this._multiplierContainer.visible == true) {
            this.setMultiplierPosition(this._resizeData.orientation);
        }
    }

    private setMultiplierPosition(orientation:string):void {
        if(orientation == Orientation.LANDSCAPE) {
            this._multiplierContainer.position = MonkeysGoldBonusGameMultiplierView.LANDSCAPE_POSITION;
            this._multiplierContainer.scale = MonkeysGoldBonusGameMultiplierView.LANDSCAPE_SCALE;
        } else {
            this._multiplierContainer.position = MonkeysGoldBonusGameMultiplierView.PORTRAIT_POSITION;
            this._multiplierContainer.scale = MonkeysGoldBonusGameMultiplierView.PORTRAIT_SCALE;
        }
    }

    public enableMultplier():void {
        this._multiplierContainer.visible = true;
        this.setMultiplierPosition(this._resizeData.orientation);
    }

    public disableMultplier():void {
        this._multiplierActiveText.reset();
        this._multiplierNextText.reset();
        this._multiplierUpcomingText.reset();
        this._multiplierContainer.visible = false;
    }

    public initMultiplierValue(multiplierValue:number):TimelineLite {
        const multiplierInitTL:TimelineLite = new TimelineLite();
        multiplierInitTL.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.MULTIPLIER_UP)}));
        multiplierInitTL.add(() => this._multiplierActiveText.setValue(multiplierValue));
        multiplierInitTL.add(() => this._multiplierNextText.setValue(multiplierValue + multiplierValue), "+=0.2");
        multiplierInitTL.add(TweenLite.fromTo(this._multiplierNextText.position, 0.1, {
            x : 294,
            ease : Linear.easeNone
        }, {
            x : 161,
            ease : Linear.easeNone
        }));
        multiplierInitTL.add(TweenLite.fromTo(this._multiplierNextText.position, 0.2, {
            x : 161,
            ease : Linear.easeNone
        }, {
            x : 181,
            ease : Linear.easeNone
        }));
        return multiplierInitTL;
    }

    public setMultiplierValue(multiplierValue:number, multiplierIncrease:number, forceNumber:boolean = false, playSound:boolean = true):TimelineLite {
        this._multiplierValue = multiplierValue;
        this._multiplierValueIncrease = multiplierIncrease;
        const multiplierUpdateTL:TimelineLite = new TimelineLite();
        if(this._multiplierUpdateExplosionAnimation) {
            if(this._isRestore == true) {
                this._isRestore = false;
                this._multiplierActiveText.setValue(this._multiplierValue);
                this._multiplierNextText.setValue(this._multiplierValue + this._multiplierValueIncrease);
            } else {
                multiplierUpdateTL.add(() => this._multiplierNextText.position.set(181, 0));
                multiplierUpdateTL.add(() => this._multiplierUpdateFrameAnimation.alpha = 0);
                multiplierUpdateTL.add(() => this._multiplierUpdateFrameAnimation.visible = true);
                multiplierUpdateTL.add([
                    new TweenLite(this._multiplierUpdateFrameAnimation, 0.3, {alpha : 1, ease : Linear.easeNone}),
                    this._multiplierUpdateExplosionAnimation.getAnimationAutoShowHide(),
                    () => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.MULTIPLIER_UP)})
                ]);
                multiplierUpdateTL.add(() => this._multiplierNextText.enableGoldText(), "-=0.1");
                multiplierUpdateTL.add(() => this._multiplierUpcomingText.position.set(294, 0));
                multiplierUpdateTL.add(() => this._multiplierUpcomingText.setValue(multiplierValue + multiplierIncrease));
                multiplierUpdateTL.add(() => this._multiplierUpcomingText.enableGrayText());
                multiplierUpdateTL.add(() => {}, "+=0.2");
                multiplierUpdateTL.add([
                    () => (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.MULTIPLIER_SWEEP)}),
                    TweenLite.fromTo(this._multiplierUpcomingText.position, 0.1, {
                        x : 294,
                        ease : Linear.easeNone
                    }, {
                        x : 161,
                        ease : Linear.easeNone
                    }),

                    TweenLite.fromTo(this._multiplierNextText.position, 0.1, {
                        x : 181,
                        ease : Linear.easeNone
                    }, {
                        x : 48,
                        ease : Linear.easeNone
                    }),

                    TweenLite.fromTo(this._multiplierActiveText.position, 0.1, {
                        x : 68,
                        ease : Linear.easeNone
                    }, {
                        x : -100,
                        ease : Linear.easeNone
                    })
                ]);

                multiplierUpdateTL.add([
                    new TweenLite(this._multiplierUpcomingText.position, 0.2, {
                        x : 181,
                        ease : Linear.easeNone
                    }),
                    new TweenLite(this._multiplierNextText.position, 0.2, {
                        x : 68,
                        ease : Linear.easeNone
                    })
                ]);

                multiplierUpdateTL.add(new TweenLite(this._multiplierUpdateFrameAnimation, 0.3, {
                    alpha : 0,
                    ease : Linear.easeNone
                }));
                multiplierUpdateTL.add(() => this._multiplierUpdateFrameAnimation.visible = false);

                multiplierUpdateTL.add(() => {
                    this._multiplierUpcomingText.position.set(294, 0);
                    this._multiplierActiveText.setValue(multiplierValue);
                    this._multiplierActiveText.enableGoldText();
                    this._multiplierActiveText.position.set(68, 0);
                    this._multiplierNextText.setValue(multiplierValue + multiplierIncrease);
                    this._multiplierNextText.enableGrayText();
                    this._multiplierNextText.position.set(181, 0);
                });
            }
        }
        return multiplierUpdateTL;
    }

    public resetMultiplier():void {
        this._multiplierActiveText.reset();
        this._multiplierNextText.reset();
        this._multiplierUpcomingText.reset();
        //this._multiplier.skeleton.setSlotsToSetupPose();
    }

    set isRestore(value:boolean) {
        this._isRestore = value;
    }
}